import styled from "styled-components";
import { LocationSelector } from "src/website-apps/shared/components/location-selector";
import { StyledDiv as LocationStyledDiv } from "src/website-apps/shared/components/location-selector/styled-components";

export const StyledHeaderSection = styled.div`
  ${({
    theme: {
      typography: { getStyles, variant },
    },
  }) => getStyles(variant.title5)};
  align-items: center;
  display: inline-flex;
  height: auto;
  margin-bottom: ${(props) => props.theme.spacing(4)};
  position: relative;
  width: max-content;

  @media ${({ theme: { media } }) => `${media.tablet}, ${media.desktop}`} {
    margin-bottom: ${(props) => props.theme.spacing(10)};
  }
`;

export const StyledText = styled.span`
  color: ${(props) => props.theme.colors.textDarker};
  margin-right: ${(props) => props.theme.spacing(1.5)};
`;

export const StyledLocationSelector = styled(LocationSelector)`
  ${({
    theme: {
      typography: { getStyles, variant },
    },
  }) => getStyles(variant.title5)};
  color: ${(props) => props.theme.colors.textBrand};
  padding: 0;
  width: max-content;

  & > div > svg {
    fill: ${(props) => props.theme.colors.textBrand};
    margin-left: ${(props) => props.theme.spacing(2)};

    &:hover {
      fill: ${(props) => props.theme.colors.textBrand};
    }
  }

  &:hover {
    & > div > svg {
      fill: ${(props) => props.theme.colors.textBrand};
    }
  }

  ${LocationStyledDiv} {
    top: calc(100% + 15px);
  }
`;
